import { render, staticRenderFns } from "./warehouseItems.vue?vue&type=template&id=4d13e562"
import script from "./warehouseItems.vue?vue&type=script&lang=js"
export * from "./warehouseItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports